// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"eHs3q":[function(require,module,exports,__globalThis) {
var _database = require("firebase/database");
var _config2 = require("./config2");
//import { initConfig } from "./compat";
var _global = require("./global");
//import { gplay } from "google-play-scraper";
//const gplay = require("google-play-scraper");
const MAX_RADIOS = 10;
const MAX_REVIEWS = 10;
const radioContainer = document.getElementById("radioContainer");
const radioTemplate = document.getElementById("radioTemplate");
const reviewsContainer = document.getElementById("reviewsContainer");
const reviewsTemplate = document.getElementById("reviewsTemplate");
const APP_ID = "app.myandroidhello.com.chatmurcianys";
let activeLs = [];
$("document").ready(function() {
    initFrameLs();
    loadTopRadios();
    loadReviews();
});
function initFrameLs() {
    window.addEventListener("beforeunload", ()=>{
        activeLs.forEach((stopLs)=>{
            stopLs();
        });
    });
}
async function loadTopRadios() {
    const radioCards = (0, _global.createSkeletons)(radioTemplate, MAX_RADIOS, radioContainer);
    const db = (0, _config2.dbApp);
    const dbRadio = (0, _database.ref)(db, `Radio Stations`);
    const radioQuery = (0, _database.query)(dbRadio, (0, _database.orderByChild)("info/numLikes"), (0, _database.limitToLast)(MAX_RADIOS));
    const radioLs = (0, _database.onValue)(radioQuery, (snapshot)=>{
        if (snapshot.exists()) {
            const topItems = [];
            snapshot.forEach((child)=>{
                const key = child.key;
                topItems.push({
                    id: key,
                    ...child.val().info
                });
            });
            topItems.reverse();
            topItems.forEach((radio)=>{
                let skeletonCard = (0, _global.getAvailableSkeleton)(radio.id, radioContainer, radioTemplate);
                setRadioCardUi(skeletonCard, radio.id, radio);
            });
        } else (0, _global.removeExtraSkeletons)(radioContainer);
    });
    activeLs.push(radioLs);
//get(radioQuery).then((data) => {});
}
function setRadioCardUi(card, key, data) {
    card.id = key;
    card.querySelector(".radio-name").textContent = data.radio_Name;
    let radioimg = card.querySelector("img");
    radioimg.src = data.radio_image || radioimg.src;
    card.querySelector("a").href = (0, _global.getRadioLink)(data.radio_Name);
    card.removeAttribute("loading");
}
async function loadReviews() {
    const reviewsList = await getReviews();
    if (reviewsList && reviewsList.length > 0) {
        reviewsList.forEach((review)=>{
            let skeletonCard = (0, _global.getAvailableSkeleton)(review.id, reviewsContainer, reviewsTemplate);
            console.log("skeleton: ", skeletonCard.querySelector(".user-name"));
            setReviewUi(skeletonCard, review);
        });
        if (reviewsContainer) {
            console.log("reviews container exists");
            (0, _global.removeExtraSkeletons)(reviewsContainer);
        } else console.log("reviewscontainer is null");
    }
}
function setReviewUi(card, review) {
    card.id = review.id;
    const imgUser = card.querySelector("img");
    imgUser.src = review.userImage || imgUser.src;
    card.querySelector(".user-name").textContent = review.userName;
    card.querySelector(".review-date").textContent = review.date;
    card.querySelector(".star-rating").innerHTML = (0, _global.getStars)(review.score);
    card.querySelector(".review-text").textContent = review.text;
    card.removeAttribute("loading");
}
async function getReviews() {
    const reviewCards = (0, _global.createSkeletons)(reviewsTemplate, MAX_RADIOS, reviewsContainer);
    try {
        // Construct the URL with query parameters
        //const url = `http://localhost:5000/api/reviews?appId=${APP_ID}&count=${MAX_REVIEWS}`;
        const url = `/gplay/reviews?appId=${APP_ID}&count=${MAX_REVIEWS}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Server error: ${response.status}`);
        const reviewsData = await response.json();
        console.log(`Fetched ${reviewsData.length} reviews:`, reviewsData.data);
        return reviewsData.data;
    } catch (error) {
        console.error("Failed to get reviews:", error);
    }
}

},{"firebase/database":"3h9CB","./config2":"9ilDI","./global":"awxwA"}],"3h9CB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _database = require("@firebase/database");
parcelHelpers.exportAll(_database, exports);

},{"@firebase/database":"b6R1F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ilDI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "app", ()=>app);
parcelHelpers.export(exports, "dbApp", ()=>dbApp);
parcelHelpers.export(exports, "dbProducts", ()=>dbProducts);
// Keep an empty initConfig function so your index.js file doesn't crash from a missing import
parcelHelpers.export(exports, "initConfig", ()=>initConfig);
var _app = require("firebase/app");
var _database = require("firebase/database");
const DATABASE_IN_APP_PRODUCTS = "https://chat-murcianys-18752.firebaseio.com/";
const DATABASE_IN_APP_PURCHASES = "https://chat-murcianys-efb7f.firebaseio.com/";
const firebaseConfig = {
    apiKey: "AIzaSyCss8833TpaKYlIrRsC_VkrxKQC-Uuf_nI",
    authDomain: "chat-murcianys.firebaseapp.com",
    databaseURL: "https://chat-murcianys.firebaseio.com",
    projectId: "chat-murcianys",
    storageBucket: "chat-murcianys.appspot.com",
    messagingSenderId: "484066067543",
    appId: "1:484066067543:web:b12e176ab6ad132a0e8f12"
};
const app = (0, _app.initializeApp)(firebaseConfig);
const dbApp = (0, _database.getDatabase)(app);
const dbProducts = (0, _database.getDatabase)(app, DATABASE_IN_APP_PRODUCTS);
function initConfig() {
// Safe to leave empty now
}

},{"firebase/app":"4uLxM","firebase/database":"3h9CB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uLxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _app = require("@firebase/app");
parcelHelpers.exportAll(_app, exports);
var name = "firebase";
var version = "12.16.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, _app.registerVersion)(name, version, 'app');

},{"@firebase/app":"iO7sa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["eHs3q"], "eHs3q", "parcelRequire460e", {})

//# sourceMappingURL=public.f3a41334.js.map
